import React, { PropTypes } from 'react';
import Logo from 'assets/images/crowdspring_badge.svg';

const ProfileBackground = ({ profile_bg }) => {
  if (!profile_bg) {
    return (
      <div className="profile-background-container">
        <div className="profile-background empty">
          <div className="svg-logo" dangerouslySetInnerHTML={{ __html: Logo }} />
        </div>
      </div>
    );
  }

  const backgroundImage = profile_bg;
  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
  };

  return (
          <div className="profile-background-container">
            <div className="profile-background" style={backgroundStyle} />
          </div>
        );
};

ProfileBackground.propTypes = {
  profile_bg: PropTypes.string,
};

export default ProfileBackground;



// WEBPACK FOOTER //
// ./profile/components/profile_background.jsx